/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

import i18n from '@/i18n'

export default [
  {
    path: '/',
    // Relative to /src/views
    view: 'layouts/Empty',
    name: 'EmptyLayout',
    meta: { requiresGuest: true },
    children: [
      {
        path: '',
        name: 'Login',
        view: 'Login'
      },
      {
        path: '/employee',
        name: 'LoginEmployee',
        view: 'LoginEmployee'
      },
      {
        path: '/forgot/password',
        view: 'ForgotPassword'
      },
      {
        path: '/password/reset/:token',
        view: 'PasswordReset'
      },
      {
        path: '/email/confirmation/:token',
        view: 'EmailConfirmation'
      }
    ]
  },
  {
    path: '/',
    name: 'AdminLayout',
    view: 'layouts/Admin',
    meta: { requiresAuth: true },
    children: [
        {
          path: '/dashboard',
          name: i18n.t('Pages.Dashboard.title'),
          view: 'Dashboard'
        },
        {
          path: '/request',
          name: i18n.t('Pages.Vacations.request_for_long'),
          view: 'vacations/Request'
        },
        {
          path: '/user-profile',
          name: i18n.t('Pages.Users.profile'),
          view: 'UserProfile'
        },
        {
          path: '/reports/users',
          name: i18n.t('Pages.Users.export'),
          view: 'Export'
        },
        {
          path: '/users',
          name: i18n.t('Pages.Users.title'),
          view: 'Users'
        },
        {
          path: '/users/add',
          name: i18n.t('Pages.Users.add_new'),
          view: 'users/Add'
        },
        {
          path: '/users/:id/update',
          name: i18n.t('Pages.Users.update'),
          view: 'users/Update'
        },
        {
          path: '/users/:id/show',
          name: i18n.t('Pages.Users.show'),
          view: 'users/Show'
        },
        {
          path: '/holidays',
          name: i18n.t('Pages.Holidays.title'),
          view: 'Holidays'
        },
        {
          path: '/holidays/add',
          name: i18n.t('Pages.Holidays.add_new'),
          view: 'holidays/Add'
        },
        {
          path: '/holidays/:id/update',
          name: i18n.t('Pages.Holidays.update'),
          view: 'holidays/Update'
        },
        {
          path: '/holidays/:id/show',
          name: i18n.t('Pages.Holidays.show'),
          view: 'holidays/Show'
        },
        {
          path: '/collective-vacations',
          name: i18n.t('Pages.CollectiveVacations.title'),
          view: 'CollectiveVacations'
        },
        {
          path: '/collective-vacations/add',
          name: i18n.t('Pages.CollectiveVacations.add_new'),
          view: 'collectiveVacations/Add'
        },
        {
          path: '/vacation-requests',
          name: i18n.t('Pages.VacationRequests.title'),
          view: 'VacationRequests'
        },
        {
          path: '/vacation-requests/:id/update',
          name: i18n.t('Pages.VacationRequests.update'),
          view: 'vacationRequests/Update'
        },
        {
          path: '/vacation-requests/:id/show',
          name: i18n.t('Pages.VacationRequests.show'),
          view: 'vacations/Show'
        },
        {
          path: '/workplaces',
          name: i18n.t('Pages.Workplaces.title'),
          view: 'Workplaces'
        },
        {
          path: '/workplaces/add',
          name: i18n.t('Pages.Workplaces.add_new'),
          view: 'workplaces/Add'
        },
        {
          path: '/workplaces/:id/update',
          name: i18n.t('Pages.Workplaces.update'),
          view: 'workplaces/Update'
        },
        {
          path: '/workplaces/:id/show',
          name: i18n.t('Pages.Workplaces.show'),
          view: 'workplaces/Show'
        },
        {
          path: '/employee-roles',
          name: i18n.t('Pages.EmployeeRoles.title'),
          view: 'EmployeeRoles'
        },
        {
          path: '/employee-roles/add',
          name: i18n.t('Pages.EmployeeRoles.add_new'),
          view: 'employeeRoles/Add'
        },
        {
          path: '/employee-roles/:id/update',
          name: i18n.t('Pages.EmployeeRoles.update'),
          view: 'employeeRoles/Update'
        },
        {
          path: '/employee-roles/:id/show',
          name: i18n.t('Pages.EmployeeRoles.show'),
          view: 'employeeRoles/Show'
        },
        {
          path: '/sectors',
          name: i18n.t('Pages.Sectors.title'),
          view: 'Sectors'
        },
        {
          path: '/sectors/add',
          name: i18n.t('Pages.Sectors.add_new'),
          view: 'sectors/Add'
        },
        {
          path: '/sectors/:id/update',
          name: i18n.t('Pages.Sectors.update'),
          view: 'sectors/Update'
        },
        {
          path: '/sectors/:id/show',
          name: i18n.t('Pages.Sectors.show'),
          view: 'sectors/Show'
        },
        {
          path: '/vacations',
          name: i18n.t('Pages.Vacations.title'),
          view: 'Vacations'
        },

        {
          path: '/vacations/:id/show',
          name: i18n.t('Pages.Vacations.show'),
          view: 'vacations/Show'
        },
        {
          path: '/reports/vacations',
          name: i18n.t('Pages.Reports.title'),
          view: 'reports/UsedVacation'
        },
        {
          path: '/overtime',
          name: i18n.t('Pages.ScheduledOvertimes.title'),
          view: 'ScheduledOvertime'
        },
        {
          path: '/overtime/add',
          name: i18n.t('Pages.ScheduledOvertimes.add_new'),
          view: 'scheduledOvertime/Add'
        },
        {
          path: '/overtime/:id/update',
          name: i18n.t('Pages.ScheduledOvertimes.update'),
          view: 'scheduledOvertime/Update'
        },
        {
          path: '/overtime/:id/show',
          name: i18n.t('Pages.ScheduledOvertimes.show'),
          view: 'scheduledOvertime/Show'
        },
        {
          path: '/vehicles',
          name: i18n.t('Pages.Vehicles.title'),
          view: 'Vehicles'
        },
        {
          path: '/vehicles/add',
          name: i18n.t('Pages.Vehicles.add_new'),
          view: 'vehicles/Add'
        },
        {
          path: '/vehicles/:id/update',
          name: i18n.t('Pages.Vehicles.update'),
          view: 'vehicles/Update'
        },
        {
          path: '/vehicles/:id/show',
          name: i18n.t('Pages.Vehicles.show'),
          view: 'vehicles/Show'
        },
        {
          path: '/travel-warrant-suggestion',
          name: i18n.t('Pages.TravelWarrantSuggestion.title'),
          view: 'TravelWarrantSuggestion'
        },
        {
          path: '/reports/overtime',
          name: i18n.t('Pages.Reports.overtime_title'),
          view: 'reports/ScheduledOvertimes'
        },
        {
          path: '/reports/warrants',
          name: i18n.t('Pages.Reports.warrants_title'),
          view: 'reports/TravelWarrants'
        },
        {
          path: '/travel-warrants',
          name: i18n.t('Pages.TravelWarrants.title'),
          view: 'TravelWarrants'
        },
        {
          path: '/travel-warrants/add',
          name: i18n.t('Pages.TravelWarrants.add_new'),
          view: 'travelWarrants/Add'
        },
        {
          path: '/travel-warrants/:id/update',
          name: i18n.t('Pages.TravelWarrants.update'),
          view: 'travelWarrants/Update'
        },
        {
          path: '/travel-warrants/:id/show',
          name: i18n.t('Pages.TravelWarrants.show'),
          view: 'travelWarrants/Show'
        },
        {
          path: '/support-tickets',
          name: i18n.t('Pages.SupportTickets.title'),
          view: 'SupportTickets'
        },
        {
          path: '/support-tickets/:id/show',
          name: i18n.t('Pages.SupportTickets.show'),
          view: 'support-tickets/Show'
        },
        {
          path: '/document-types',
          name: i18n.t('Pages.DocumentTypes.title'),
          view: 'DocumentTypes'
        },
        {
          path: '/partners',
          name: i18n.t('Pages.Partners.title'),
          view: 'Partners'
        },
        {
          path: '/real-locations',
          name: i18n.t('Pages.RealLocations.title'),
          view: 'RealLocations'
        },
        {
          path: '/record-book-types',
          name: i18n.t('Pages.RecordBookTypes.title'),
          view: 'RecordBookTypes'
        },
        {
          path: '/transport-types',
          name: i18n.t('Pages.TransportTypes.title'),
          view: 'TransportTypes'
        },
        {
          path: '/record-books',
          name: i18n.t('Pages.RecordBooks.title'),
          view: 'RecordBooks'
        },
        {
          path: '/record-books/add',
          name: i18n.t('Pages.RecordBooks.add_new'),
          view: 'recordBooks/Add'
        },
        {
          path: '/record-books/:id/update',
          name: i18n.t('Pages.RecordBooks.update'),
          view: 'recordBooks/Update'
        },
        {
          path: '/record-books/:id/show',
          name: i18n.t('Pages.RecordBooks.show'),
          view: 'recordBooks/Show'
        },
        {
          path: '/deleted-record-books/:id/show',
          name: i18n.t('Pages.RecordBooks.show_deleted'),
          view: 'recordBooks/ShowDeleted'
        },
        {
          path: '/warehouses',
          name: i18n.t('Pages.Warehouses.title'),
          view: 'Warehouses'
        },
        {
          path: '/warehouses/add',
          name: i18n.t('Pages.Warehouses.add_new'),
          view: 'warehouses/Add'
        },
        {
          path: '/warehouses/:id/update',
          name: i18n.t('Pages.Warehouses.update'),
          view: 'warehouses/Update'
        },
        {
          path: '/warehouses/:id/show',
          name: i18n.t('Pages.Warehouses.show'),
          view: 'warehouses/Show'
        },
        {
          path: '/products',
          name: i18n.t('Pages.Products.title'),
          view: 'Products'
        },
        {
          path: '/products/add',
          name: i18n.t('Pages.Products.add_new'),
          view: 'products/Add'
        },
        {
          path: '/products/:id/update',
          name: i18n.t('Pages.Products.update'),
          view: 'products/Update'
        },
        {
          path: '/products/:id/show',
          name: i18n.t('Pages.Products.show'),
          view: 'products/Show'
        },
        {
          path: '/manufacturers',
          name: i18n.t('Pages.Manufacturers.title'),
          view: 'Manufacturers'
        },
        {
          path: '/manufacturers/add',
          name: i18n.t('Pages.Manufacturers.add_new'),
          view: 'manufacturers/Add'
        },
        {
          path: '/manufacturers/:id/update',
          name: i18n.t('Pages.Manufacturers.update'),
          view: 'manufacturers/Update'
        },
        {
          path: '/manufacturers/:id/show',
          name: i18n.t('Pages.Manufacturers.show'),
          view: 'manufacturers/Show'
        },
        {
          path: '/groupations',
          name: i18n.t('Pages.Groupations.title'),
          view: 'Groupations'
        },
        {
          path: '/groupations/add',
          name: i18n.t('Pages.Groupations.add_new'),
          view: 'groupations/Add'
        },
        {
          path: '/groupations/:id/update',
          name: i18n.t('Pages.Groupations.update'),
          view: 'groupations/Update'
        },
        {
          path: '/groupations/:id/show',
          name: i18n.t('Pages.Groupations.show'),
          view: 'groupations/Show'
        },
        {
          path: '/product-sizes',
          name: i18n.t('Pages.ProductSizes.title'),
          view: 'ProductSizes'
        },
        {
          path: '/product-sizes/add',
          name: i18n.t('Pages.ProductSizes.add_new'),
          view: 'productSizes/Add'
        },
        {
          path: '/product-sizes/:id/update',
          name: i18n.t('Pages.ProductSizes.update'),
          view: 'productSizes/Update'
        },
        {
          path: '/product-sizes/:id/show',
          name: i18n.t('Pages.ProductSizes.show'),
          view: 'productSizes/Show'
        },
        {
          path: '/workplace-product-rules/add',
          name: i18n.t('Pages.WorkplaceProductRules.add_new'),
          view: 'workplaceProductRules/Add'
        },
        {
          path: '/workplace-product-rules/:id/update',
          name: i18n.t('Pages.WorkplaceProductRules.update'),
          view: 'workplaceProductRules/Update'
        },
        {
          path: '/workplace-product-rules/:id/show',
          name: i18n.t('Pages.WorkplaceProductRules.show'),
          view: 'workplaceProductRules/Show'
        },
        {
          path: '/user-checkout-forms',
          name: i18n.t('Pages.UserCheckoutForms.title'),
          view: 'UserCheckoutForms'
        },
        {
          path: '/user-checkout-forms/add',
          name: i18n.t('Pages.UserCheckoutForms.add_new'),
          view: 'userCheckoutForms/Add'
        },
        {
          path: '/user-checkout-forms/add/:id',
          name: i18n.t('Pages.UserCheckoutForms.add_new'),
          view: 'userCheckoutForms/Add'
        },
        {
          path: '/user-checkout-forms/:id/update',
          name: i18n.t('Pages.UserCheckoutForms.update'),
          view: 'userCheckoutForms/Update'
        },
        {
          path: '/user-checkout-forms/:id/show',
          name: i18n.t('Pages.UserCheckoutForms.show'),
          view: 'userCheckoutForms/Show'
        },
        {
          path: '/reports/warehouse-states',
          name: i18n.t('Pages.Reports.warehouse_states_title'),
          view: 'reports/WarehouseStates'
        },
        {
          path: '/reports/user-checkout-forms',
          name: i18n.t('Pages.Reports.user_checkout_forms_title'),
          view: 'reports/UserCheckoutForms'
        },
        {
            path: '/electricity-stats',
            name: i18n.t('Pages.ElectricityStats.title'),
            view: 'ElectricityStats'
        },
        {
            path: '/electricity-constants',
            name: i18n.t('Pages.ElectricityConstants.title'),
            view: 'ElectricityConstants'
        },
        {
            path: '/electricity-constants/:id/update',
            name: i18n.t('Pages.ElectricityConstants.update'),
            view: 'electricityConstants/Update'
        },
        {
            path: '/electricity-constants/:id/show',
            name: i18n.t('Pages.ElectricityConstants.show'),
            view: 'electricityConstants/Show'
        },
        {
            path: '/electricity-suppliers',
            name: i18n.t('Pages.ElectricitySuppliers.title'),
            view: 'ElectricitySuppliers'
        },
        {
            path: '/electricity-suppliers/add',
            name: i18n.t('Pages.ElectricitySuppliers.add_new'),
            view: 'electricitySuppliers/Add'
        },
        {
            path: '/electricity-suppliers/:id/update',
            name: i18n.t('Pages.ElectricitySuppliers.update'),
            view: 'electricitySuppliers/Update'
        },
        {
            path: '/electricity-suppliers/:id/show',
            name: i18n.t('Pages.ElectricitySuppliers.show'),
            view: 'electricitySuppliers/Show'
        },
        {
            path: '/electricity-bills',
            name: i18n.t('Pages.ElectricityBills.title'),
            view: 'ElectricityBills'
        },
        {
            path: '/electricity-bills/add',
            name: i18n.t('Pages.ElectricityBills.add_new'),
            view: 'electricityBills/Add'
        },
        {
            path: '/electricity-bills/:id/update',
            name: i18n.t('Pages.ElectricityBills.update'),
            view: 'electricityBills/Update'
        },
        {
            path: '/electricity-bills/:id/show',
            name: i18n.t('Pages.ElectricityBills.show'),
            view: 'electricityBills/Show'
        },
    ]
  }

]
